import React, { useEffect, useState } from "react";
import ImageUploadWithCrop from "../../../CoreComponents/ImageUploadWithCrop";
import { franchise } from "../../../Functionalities/Config";
import { showMessage } from "../../../Functionalities/Functions";
import CategoryTilePreview from "./CategoryTilePreview";
import { fetchHomeTiles, saveUmbrellaImage } from "./categoryPictureData";

const TILE_SIZE = 256;

export default function CategoryPictureStep({ umbrella, onDone }) {
  const [neighbours, setNeighbours] = useState([]);
  const [file, setFile] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let live = true;
    fetchHomeTiles(franchise).then((tiles) => live && setNeighbours(tiles.filter((tile) => tile.id !== umbrella.id)));
    return () => {
      live = false;
    };
  }, [umbrella.id]);

  const save = async () => {
    setSaving(true);
    const saved = await saveUmbrellaImage(umbrella.id, file);
    setSaving(false);
    if (saved.error) {
      showMessage(saved.error, "danger", "Failed!", "top", "top-right", 0);
      return;
    }
    showMessage(`Picture saved for ${umbrella.name}`, "success", "Success!", "top", "top-right", 0);
    onDone();
  };

  return (
    <section className="cns">
      <h4 className="cns__title">Add a picture for {umbrella.name}</h4>
      <p className="cns__note">
        Customers see it in the category row on the app's home. Design its shape and background to match the dish; the
        app shows it exactly as uploaded. A PNG with a transparent background keeps the app's background behind it.
      </p>
      <ImageUploadWithCrop value={file} onChange={setFile} aspectRatio={1} lockShape compressMaxRes={TILE_SIZE} outputType="image/png" />
      <CategoryTilePreview name={umbrella.name} image={file || null} neighbours={neighbours} />
      <div className="cns__buttons">
        <button type="button" className="btn btn-primary" disabled={!file || saving} onClick={save}>
          Save picture
        </button>
        <button type="button" className="btn btn-light" disabled={saving} onClick={onDone}>
          Skip
        </button>
      </div>
    </section>
  );
}
